var metaInfo={
    title:"工业机器人_Movibot服务行业",
    keywords:"中国工业机器人_减速机_伺服电机_工业机器人_控制系统_机器视觉系统",
    description:"中国工业机器人上下游产业链核心零部件、机器人本体、系统集成中的多个品牌，产品有减速机、伺服电机、并联机器人、串联机器人、移动机器人、协作机器人、机器控制系统、机器视觉系统等",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/1.js